import React, { useState, useEffect } from 'react';
import Navbar from '../../components/layout/Navbar';
import { SALES_ORDER_SEARCH_API_WITH_FILTERS } from '../../config/api';
import { decryptData } from '../../utils/encrypt';
import { useNavigate } from 'react-router-dom';
import SalesInvoiceSearchFilters from './cards/SalesInvoiceSearchFilters';
import SalesInvoiceSearchTable from './cards/SalesInvoiceSearchTable';

function SalesInvoiceSearch() {
  const [filters, setFilters] = useState({
    customer_name: '',
    customer_po_no: '',
    po_date_from: '',
    po_date_to: '',
    vehicle_status: 'done',
    billing_status: 'pending'
  });
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const navigate = useNavigate();

  const fmt = (d) => d.toISOString().split('T')[0];

  useEffect(() => {
    const storedUser = localStorage.getItem('suyog_user');
    const storedOrg = localStorage.getItem('suyog_selected_org');

    if (storedUser) {
      const parsed = decryptData(storedUser);
      setUserId(parsed.user_id || null);
    }

    if (storedOrg) {
      const parsedOrg = JSON.parse(storedOrg);
      setOrgId(parsedOrg.value || null);
    }

    // ✅ Default range: today - 10 days to today + 10 days
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(fromDate.getDate() - 10);
    const toDate = new Date(today);
    toDate.setDate(toDate.getDate() + 10);

    setFilters((prev) => ({
      ...prev,
      po_date_from: fmt(fromDate),
      po_date_to: fmt(toDate),
    }));
  }, []);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!userId || !orgId) return alert('User or Org not loaded.');
    setLoading(true);
    try {
      const res = await fetch(SALES_ORDER_SEARCH_API_WITH_FILTERS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...filters, user_id: userId, org_id: orgId })
      });
      const json = await res.json();
      const transformed = (json.data || []).map((item) => {
        const dispatches = item.dispatches || [];
        const invoices = item.invoices || [];
        return { ...item, dispatches, invoices };
      });
      setRecords(transformed);
    } catch (err) {
      console.error('Fetch error:', err);
      alert('Server error');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    // ✅ Reset to the same default range: today - 10 days to today + 10 days
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(fromDate.getDate() - 10);
    const toDate = new Date(today);
    toDate.setDate(toDate.getDate() + 10);

    setFilters({
      customer_name: '',
      customer_po_no: '',
      po_date_from: fmt(fromDate),
      po_date_to: fmt(toDate),
      vehicle_status: 'done',
      billing_status: 'pending'
    });
    setRecords([]);
  };

  // ---- SAME TAB navigation ----
  const handleCreateInvoice = (dispatchIds) => {
    if (!dispatchIds || dispatchIds.length === 0) {
      return alert('Dispatch ID not found.');
    }
    const ids = dispatchIds.map((id) => encodeURIComponent(String(id))).join(',');
    navigate(`/salesinvoice/new?dispatch_ids=${ids}`);
  };

  const handleViewInvoice = (invoiceId) => {
    if (!invoiceId) return alert('Invoice ID missing');
    const id = encodeURIComponent(String(invoiceId));
    navigate(`/salesinvoice/view?id=${id}`);
  };

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="card shadow-sm p-4">
          <h4 className="mb-3 text-success">Sales Invoice Records</h4>

          <SalesInvoiceSearchFilters
            filters={filters}
            onChange={handleChange}
            onSearch={handleSearch}
            onReset={handleReset}
            loading={loading}
          />

          <SalesInvoiceSearchTable
            records={records}
            onCreateInvoice={handleCreateInvoice}
            onViewInvoice={handleViewInvoice}
          />
        </div>
      </div>
    </>
  );
}

export default SalesInvoiceSearch;
